"use client";
import { Suspense } from "react";
import { register } from "swiper/element/bundle";

import Skeleton from "@/components/ui/Skeleton";

import SwiperGallery from "./SwiperGallery";
import styles from "./media-gallery.module.css";
register();

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "swiper-container": any;
      "swiper-slide": any;
    }
  }
}

const ProductMedia = () => {
  return (
    <div className={styles.root}>
      <div className={styles.gallery__container__inner}>
        <Suspense fallback={<Skeleton height="100%" />}>
          <SwiperGallery className={styles.swiper} />
        </Suspense>
      </div>
    </div>
  );
};

export default ProductMedia;
